/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2025-03-14 11:33:05
 **/

/**
 * A class to manage asynchronous tasks with the ability to cancel them.
 *
 * This class allows an asynchronous task to be executed and provides a mechanism
 * to cancel the task. If the task is canceled, the promise is rejected
 * with an error indicating that the task was canceled.
 *
 * @template T The type of the value that the managed task resolves with.
 */
export default class CancelableTask<T = void> {
	#resolvers = Promise.withResolvers<T>();
	#rejected = false;

	constructor(private readonly handler: () => Promise<T>) {}

	public execute() {
		if (!this.#rejected) {
			this.handler().then(this.#resolvers.resolve, this.#resolvers.reject);
		}
		return this.#resolvers.promise;
	}

	public cancel() {
		this.#rejected = true;
		this.#resolvers.reject(new Error("Canceled"));
	}
}
